import React, { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// eslint-disable-next-line no-unused-vars
import { deleteFile, removeQuiz, updateQuestionCount } from '../../store/actions/quizActions/quizActions'
import { useLocation, useNavigate } from 'react-router-dom'
// eslint-disable-next-line no-unused-vars
import { fileUploadRequest } from '../../utils/helpers'
import GeneralButton from '../../_atomic-design/atoms/Button/GeneralButton'
import HiddenInput from '../../_atomic-design/atoms/Home/HiddenInput'
import FileBar from '../../_atomic-design/molecules/CreateQuiz/FileBar'
import FileIcon from '../../assets/images/Icons/UploadIcon.svg'
import ImageTag from '../../_atomic-design/atoms/ImageTag'
import TextBody from '../../_atomic-design/atoms/Text/TextBody'
// import QuizLimitationModal from '../Modals/QuizLimitationModal'

export default function UploadComponent ({ setShowLimitationModel }) {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const authState = useSelector((state) => state.authReducer)
  const activeSubscription = authState.activeSubscription ? authState.activeSubscription : false
  const userSubscription = activeSubscription ? authState.subscription[authState.subscription.length - 1] : null

  const [fileList, setFileList] = useState([])
  const overlayRef = useRef(null)
  const [noOfSub, setNoOfSub] = useState(5)
  const [suberrmessage, setSuberrmessage] = useState('')
  const [noOfObj, setNoOfObj] = useState(5)
  // eslint-disable-next-line no-unused-vars
  const [disabledCreatequiz, setDisabledCreatequiz] = useState(false)
  // const [showLimitationmodel, setShowLimitationmodel] = useState(false)

  function setShowLimitationmodel (visibility) {
    setShowLimitationModel(visibility)
    setSuberrmessage('')
  }

  // eslint-disable-next-line no-unused-vars

  const wrapperRef = useRef(null)
  const onDragEnter = () => {
    overlayRef.current.style.opacity = 0.05
    wrapperRef.current.classList.add('dragover')
  }
  const onDragLeave = () => {
    overlayRef.current.style.opacity = 0
    wrapperRef.current.classList.remove('dragover')
  }

  const onDrop = () => {}

  const onFileDrop = async (e) => {
    changeHeightFunc(true)
    const newFiles = e.target.files
    if (isLimitReached(newFiles)) {
      e.target.value = null // clear input field
      return
    }
    setSuberrmessage('') // clearing error message if no file selected errror happened.

    if (newFiles) {
      // Convert newFiles to an array to be able to use filter and map
      const newFilesArray = Array.from(newFiles)
      // Filter out duplicate files based on their names
      const uniqueNewFiles = newFilesArray.filter(newFile => {
        return !fileList.some(existingFile => existingFile.name === newFile.name)
      })
      const updatedList = [...fileList, ...uniqueNewFiles]
      setFileList(updatedList)
    }
    e.target.value = null // clear input filed after processing uploaded file
  }

  const fileRemove = (file, url) => {
    setFileList(fileList.filter((item) => item !== file))
    dispatch(deleteFile({ url: url }))
  }

  useEffect(() => {
    if (fileList.length === 0) {
      changeHeightFunc(false)
    }
  }, [fileList])

  const changeNoSub = (e) => {
    let val = e.target.value
    if (val < 1) {
      if (noOfObj < 1) {
        val = 1
      } else {
        val = 0
      }
    }
    const nval = Number(val)
    const errormessage1 = 'Please login to add more questions'
    if (!authState.isLoggedIn && nval > 5) {
      setSuberrmessage(errormessage1)
      setShowLimitationmodel(true)
      setNoOfSub(5)
      dispatch(updateQuestionCount({ subQues: 5, objQues: noOfObj }))
      return
    } else {
      setSuberrmessage('')
      setShowLimitationmodel(false)
    }
    if (nval > 20) {
      setNoOfSub(20)
      dispatch(updateQuestionCount({ subQues: 20, objQues: noOfObj }))
      return
    }
    setNoOfSub(nval)
    dispatch(updateQuestionCount({ subQues: nval, objQues: noOfObj }))
  }
  const changeNoObj = (e) => {
    let val = e.target.value
    if (val < 1) {
      if (noOfSub < 1) {
        val = 1
      } else {
        val = 0
      }
    }
    const nval = Number(val)
    const errormessage2 = 'Please login to add more questions'
    if (!authState.isLoggedIn && nval > 5) {
      setSuberrmessage(errormessage2)
      setShowLimitationmodel(true)
      setNoOfObj(5)
      dispatch(updateQuestionCount({ objQues: 5, subQues: noOfSub }))
      return
    } else {
      setSuberrmessage('')
      setShowLimitationmodel(false)
    }
    if (nval > 20) {
      setNoOfObj(20)
      dispatch(updateQuestionCount({ objQues: 20, subQues: noOfSub }))
      return
    }
    setNoOfObj(nval)
    dispatch(updateQuestionCount({ objQues: nval, subQues: noOfSub }))
  }

  // const uploadFiles = async (files) => {
  //   setDisabled(true)
  //   for (let i = 0; i < files.length; i++) {
  //     const formData = new FormData()
  //     formData.append('image', files[i])
  //     const res = await fileUploadRequest('/upload', formData)
  //     setUploadedFiles((uploadedFiles) => [...uploadedFiles, res.data.url])
  //     dispatch(storeFileSuccess({ url: res.data.url }))
  //   }
  //   setDisabled(false)
  // }

  const handleSubmit = async () => {
    if (fileList.length > 0) {
      navigate('/GeneratingQuiz' + location.search)
    } else {
      setSuberrmessage('A minimum of one file must be uploaded.')
    }
  }

  const handleSubDecrement = async () => {
    let val = Number(noOfSub) - 1
    if (val < 1) {
      if (noOfObj < 1) {
        val = 1
      } else {
        val = 0
      }
    }
    const errormessage3 = 'Please login to add more questions'
    if (!authState.isLoggedIn && val > 5) {
      setSuberrmessage(errormessage3)
      setShowLimitationmodel(true)
      setNoOfSub(5)
      dispatch(updateQuestionCount({ subQues: 5, objQues: noOfObj }))
      return
    } else {
      setSuberrmessage('')
      setShowLimitationmodel(false)
    }
    if (val > 20) {
      setNoOfSub(20)
      dispatch(updateQuestionCount({ subQues: 20, objQues: noOfObj }))
      return
    }
    setNoOfSub(val)
    dispatch(updateQuestionCount({ subQues: val, objQues: noOfObj }))
  }

  const handleSubIncrement = async () => {
    const val = Number(noOfSub) + 1
    const errormessage4 = 'Please login to add more questions'
    if (!authState.isLoggedIn && val > 5) {
      setSuberrmessage(errormessage4)
      setShowLimitationmodel(true)
      setNoOfSub(5)
      dispatch(updateQuestionCount({ subQues: 5, objQues: noOfObj }))
      return
    } else {
      setSuberrmessage('')
      setShowLimitationmodel(false)
    }
    if (val > 20) {
      setNoOfSub(20)
      dispatch(updateQuestionCount({ subQues: 20, objQues: noOfObj }))
      return
    }
    setNoOfSub(val)
    dispatch(updateQuestionCount({ subQues: val, objQues: noOfObj }))
  }

  const handleObjDecrement = async () => {
    let val = Number(noOfObj) - 1
    if (val < 1) {
      if (noOfSub < 1) {
        val = 1
      } else {
        val = 0
      }
    }
    const errormessage5 = 'Please login to add more questions'
    if (!authState.isLoggedIn && val > 5) {
      setSuberrmessage(errormessage5)
      setShowLimitationmodel(true)
      setNoOfObj(5)
      dispatch(updateQuestionCount({ subQues: noOfSub, objQues: 5 }))
      return
    } else {
      setSuberrmessage('')
      setShowLimitationmodel(false)
    }
    if (val > 20) {
      setNoOfObj(20)
      dispatch(updateQuestionCount({ subQues: noOfSub, objQues: 20 }))
      return
    }
    setNoOfObj(val)
    dispatch(updateQuestionCount({ subQues: noOfSub, objQues: val }))
  }

  const handleObjIncriment = async () => {
    const val = Number(noOfObj) + 1
    const errormessage5 = 'Please login to add more questions'
    if (!authState.isLoggedIn && val > 5) {
      setSuberrmessage(errormessage5)
      setShowLimitationmodel(true)
      setNoOfObj(5)
      dispatch(updateQuestionCount({ subQues: noOfSub, objQues: 5 }))
      return
    } else {
      setSuberrmessage('')
      setShowLimitationmodel(false)
    }
    if (val > 20) {
      setNoOfObj(20)
      dispatch(updateQuestionCount({ subQues: noOfSub, objQues: 20 }))
      return
    }
    setNoOfObj(val)
    dispatch(updateQuestionCount({ subQues: noOfSub, objQues: val }))
  }

  const changeHeightFunc = (change) => {
    const width = window.innerWidth
    if (change) {
      wrapperRef.current.style.height = width >= 640 ? '250px' : '180px'
    } else {
      wrapperRef.current.style.height = width >= 640 ? '350px' : '200px'
    }
  }

  // To check if the file limit is reached for a particular user
  const isLimitReached = (newFiles) => {
    const totalFiles = newFiles.length + fileList.length
    const totalFilesSize = getFilesSize(newFiles)
    const errormessageFileSize = 'This file is empty , please check your file'
    if (totalFilesSize <= 0) {
      setSuberrmessage(errormessageFileSize)
      return true
    } else {
      setSuberrmessage('')
    }
    for (let i = 0; i < newFiles.length; i++) {
      if ((newFiles[i].type === 'application/pdf') || (newFiles[i].type === 'text/plain') || (newFiles[i].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
        setSuberrmessage('')
      } else {
        setSuberrmessage('You can only upload .docx,.pdf, or.txt files.')
        return true
      }
    }

    if (userSubscription === null) {
      const errormessage55 = 'You can only upload 1 files and max 2MB total, please login to increase limit.'
      if ((totalFiles > 1) || (totalFilesSize >= 2)) {
        setSuberrmessage(errormessage55)
        return true
      } else {
        setSuberrmessage('')
      }
    } else {
      if (userSubscription.name === 'Free') {
        const errormessage45 = `You can only upload ${userSubscription.maxDocuments} files and max ${userSubscription.maxStudents}MB total, please upgrade to increase limit.`
        if ((totalFiles > userSubscription.maxDocuments) || (totalFilesSize >= userSubscription.maxStudents)) {
          setSuberrmessage(errormessage45)
          return true
        } else {
          setSuberrmessage('')
        }
      } else if (userSubscription.name === 'Personal') {
        const errormessage222 = `You can only upload ${userSubscription.maxDocuments} files and max ${userSubscription.maxStudents}MB total, please upgrade to increase limit.`
        if ((totalFiles > userSubscription.maxDocuments) || (totalFilesSize >= userSubscription.maxStudents)) {
          setSuberrmessage(errormessage222)
          return true
        } else {
          setSuberrmessage('')
        }
      } else if (userSubscription.name === 'Enterprise') {
        const errormessage235 = `You can only upload ${userSubscription.maxDocuments} files and max ${userSubscription.maxStudents}MB total, please contactus to increase limit.`
        if ((totalFiles > userSubscription.maxDocuments) || (totalFilesSize >= userSubscription.maxStudents)) {
          setSuberrmessage(errormessage235)
          return true
        } else {
          setSuberrmessage('')
        }
      }
    }
  }

  const getFilesSize = (files) => {
    let totalSize = 0
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const fileSize = file.size
      const fileSizeMB = fileSize / 1024 / 1024
      totalSize += fileSizeMB
    }
    return totalSize
  }

  useEffect(() => {
    dispatch(removeQuiz({}))
    return () => {
    }
  }, [])

  return (
    <div className="w-full max-w-[520px] rounded-2xl p-3 md:p-5 z-10 backdrop-blur-[34px] bg-white/40 shadow-md md:shadow-xl">
            <div
                // eslint-disable-next-line quotes
                className={`w-full relative duration-500 group h-56 sm:h-[350px] bg-white/30 flex justify-center items-center flex-col cursor-pointer mb-5 rounded-lg`}
                ref={wrapperRef}
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                <ImageTag src={FileIcon} />
                <p className="text-center text-2xl font-bold text-[#3C38CD] opacity-50">
                    Upload your content. <br></br>
                    (.docx, .pdf, .txt)
                </p>
                <HiddenInput onChange={onFileDrop} acceptFileTypes=".txt,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf" multiple />
                <div
                    ref={overlayRef}
                    className="w-full h-full absolute group-hover:opacity-5 bg-black opacity-0 transition-all duration-300"
                ></div>
            </div>

            {
                fileList.map((item, key) => {
                  return <FileBar key={key} file={item} removeFile={fileRemove} setDisabled={setDisabledCreatequiz}/>
                })
            }

            <div className="flex flex-col gap-y-4 justify-between px-0 my-8 w-full mx-auto  ">
               <div className="p-4 px-10 bg-white/30 w-full border border-indigo-600 rounded-lg grid gap-4">
               {suberrmessage && (
        <TextBody text={suberrmessage} className={`text-sm text-red-800 float-left ${suberrmessage ? '' : 'hidden'}`} />
               )}
                 <div>Number Of Questions </div>
                <div className="flex flex-row justify-between w-full ">
                  <div className="flex items-center">
                    {/* <input type="checkbox" /> */}
                    <TextBody text={'Subjective'} />
                  </div>
                  <div className="flex flex-row  bg-white border-app-primary border rounded-md">
                <GeneralButton
                // eslint-disable-next-line quotes
                className={'h-8 rounded-md w-8 text-black text-xl flex justify-center items-center  cursor-pointer'}
                content={'-'}
                onClick={handleSubDecrement}
                disabled={false}
                />
                    <input type="number" id='subjective_question_number' onChange={changeNoSub} value={noOfSub.toString()} min={0} max={!authState.isLoggedIn ? 6 : 99999 } className='w-12 h-8 text-center rounded-lg' />
                <GeneralButton
                // eslint-disable-next-line quotes
                className={'h-8 rounded-md w-8 text-black text-xl flex justify-center items-center  cursor-pointer'}
                content={'+'}
                onClick={handleSubIncrement}
                disabled={false}
                />
                    </div>
                </div>
                <div className="flex flex-row justify-between w-full ">
                  <div className="flex items-center">
                    {/* <input type="checkbox" /> */}
                    <TextBody text={'Objective'} />
                  </div>
                  <div className="flex flex-row bg-white border-app-primary border rounded-md">
                  <GeneralButton
                // eslint-disable-next-line quotes
                className={'h-8 rounded-md w-8 text-black text-xl flex justify-center items-center  cursor-pointer'}
                content={'-'}
                onClick={handleObjDecrement}
                disabled={false}
                />
                    <input type="number" id='objective_question_number' onChange={changeNoObj} value={noOfObj.toString()} min={0} max={!authState.isLoggedIn ? 6 : 99999 } className='w-12 h-8 text-center rounded-lg' />
                    <GeneralButton
                // eslint-disable-next-line quotes
                className={'h-8 rounded-md w-8 text-black text-xl flex justify-center items-center  cursor-pointer'}
                content={'+'}
                onClick={handleObjIncriment}
                disabled={false}
                />
                  </div>
                </div>
                </div>
                <div className="flex flex-row gap-14 justify-center w-full">
                <GeneralButton
                // eslint-disable-next-line quotes
                id='create_quiz_button'
                className={`h-11 rounded-full w-full text-white text-xl flex justify-center items-center ${disabledCreatequiz ? 'bg-app-grey cursor-not-allowed' : 'bg-gradient-to-r from-[#3C38CD] to-[#CE8CDD] cursor-pointer'}`}
                content={disabledCreatequiz ? 'Uploading.. ' : 'Create Quiz'}
                onClick={disabledCreatequiz ? null : handleSubmit}
                disabled={disabledCreatequiz}
                />
                </div>

                <div className="flex flex-row justify-between w-full ">
                  <div className="flex items-center">
                    {/* <input type="checkbox" /> */}
                    <TextBody text={''} />
                  </div>
                  <div className="">
                  <a className="text-app-primary text-sm underline font-semibold items-left" href="data:application/pdf;base64,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" download>Download Sample document</a>

                  </div>
                </div>
            </div>
        </div>
  )
}
